<template>
  <luma-empty>
    <div>
      <b-row>
        <b-col>
          <b-card-group columns v-if="sidebar_items">
            <b-link   v-for="(i,k) in sidebar_items"
                      :key="k"
                      :to="{name:i['route_name']}" >
              <b-card class="box text-center">
                <template v-slot:header>

                  <h4 >{{$t('sidebar.'+k+'.label')}}</h4>
                </template>
                <h1 class="icon" ><i :class="i.icon"></i></h1>
              </b-card>
            </b-link>
          </b-card-group>
        </b-col>
        <b-col >

            <luma-user-info></luma-user-info>

        </b-col>
      </b-row>
    </div>

  </luma-empty>
</template>

<script>

  import LumaEmpty from "@/layout/LumaEmpty";
  import MainSidebar from "@/mixins/main_sidebar"
  import LumaUserInfo from "./luma-user-info";
  import MainView from "../../components/layout/main-view";

  export default {
    name: "Dashboard",
    mixins:[MainSidebar],
    components: {
      MainView,
      LumaUserInfo,
      LumaEmpty
    }
  }
</script>

<style scoped>
  .icon{
    font-size: 400%;
  }
  .box{
    min-width: 180px;
    /*min-height: 180px;*/
    max-width: 220px;
    height: 220px;

    margin:16px;
  }
</style>



// WEBPACK FOOTER //
// src/views/General/Dashboard.vue